import { api } from '../api/client';

export async function refreshToken(refresh_token: string) {
  const response = await api.post('/api/auth/refresh', { refresh_token });
  return response.data;
} 